import React, { useState } from 'react';
import { Button } from '@components/Button';
import { Copy, Check } from '@phosphor-icons/react';

interface LinkKitButtonProps {
  token_kit: string;
}

export const LinkKitButton: React.FC<LinkKitButtonProps> = ({ token_kit }) => {
  const [copied, setCopied] = useState(false);

  function handleCopy() {
    const url = `${window.location.origin}/kit-externo?token=${token_kit}`;
    navigator.clipboard.writeText(url).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    });
  }

  return (
    <Button
      title={copied ? 'Link copiado!' : 'Copiar Link do Kit'}
      icon={copied ? <Check size={20} /> : <Copy size={20} />}
      variantstyle="SECUNDARY"
      onClick={handleCopy}
    />
  );
};
